import { connect } from "react-redux";
import { changeValue } from "../../../store/action/cartAction";

const Note = (props) => {
   const { carts, changeValue } = props;
   const onChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      changeValue(name, value)
   }

   return (
      <div className="list-cart-container">
         <div className="title-container">
            <div className="svg-next-icon icon-title" >
            </div>
            <span className="title">
               Ghi chú giao hàng
               <span className="sub-title">(Không bắt buộc)</span>
            </span>
         </div>
         <div className="shipping-method-container">
            <textarea placeholder="Nhập Ghi chú" className="app-ui-textarea input-shipment note " rows="1" onChange={onChange} value={carts.shipping_note} name="shipping_note">
            </textarea>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
   changeValue
})(Note)
